export default __webpack_public_path__ + "static/media/orden-venta-ver.385fe1b2.svg";